const services = [
  { id: "s1", title_tr: "Ceza Hukuku", title_en: "Criminal Law", description_tr: "Ceza davalarında uzman savunma ve danışmanlık hizmetleri.", description_en: "Expert defense and consultancy in criminal cases.", detail_tr: "Ceza hukuku alanında geniş deneyim ile müvekkillerimize en iyi savunmayı sunuyoruz.", detail_en: "We provide the best defense with extensive experience in criminal law.", category: "criminal", icon: "Shield", slug: "ceza-hukuku", is_active: true },
  { id: "s2", title_tr: "Aile Hukuku", title_en: "Family Law", description_tr: "Boşanma, velayet, nafaka ve aile içi uyuşmazlıklarda profesyonel destek.", description_en: "Professional support in divorce, custody, alimony and family disputes.", detail_tr: "Aile hukuku süreçlerinde yanınızda oluyoruz.", detail_en: "We are by your side in family law processes.", category: "family", icon: "Heart", slug: "aile-hukuku", is_active: true },
  { id: "s3", title_tr: "İş Hukuku", title_en: "Labor Law", description_tr: "İşçi-işveren uyuşmazlıkları, tazminat ve işe iade davaları.", description_en: "Employee-employer disputes, compensation and reinstatement cases.", detail_tr: "İş hukuku kapsamında haklarınızı savunuyoruz.", detail_en: "We defend your rights within the scope of labor law.", category: "labor", icon: "Briefcase", slug: "is-hukuku", is_active: true },
  { id: "s4", title_tr: "Ticaret Hukuku", title_en: "Commercial Law", description_tr: "Şirket kurulumu, sözleşmeler, ticari uyuşmazlıklar ve hukuki danışmanlık.", description_en: "Company formation, contracts, commercial disputes and legal consultancy.", detail_tr: "Ticari hayatınızda güvenilir hukuk ortağınız.", detail_en: "Your reliable legal partner in business life.", category: "commercial", icon: "Building2", slug: "ticaret-hukuku", is_active: true },
  { id: "s5", title_tr: "İcra ve İflas Hukuku", title_en: "Enforcement & Bankruptcy Law", description_tr: "Alacak tahsilatı, icra takibi ve iflas süreçlerinde hukuki destek.", description_en: "Legal support in debt collection, enforcement and bankruptcy processes.", detail_tr: "Alacak haklarınızı en etkin şekilde takip ediyoruz.", detail_en: "We follow up your receivables in the most effective way.", category: "enforcement", icon: "Gavel", slug: "icra-iflas-hukuku", is_active: true },
  { id: "s6", title_tr: "Gayrimenkul Hukuku", title_en: "Real Estate Law", description_tr: "Tapu işlemleri, kira uyuşmazlıkları ve gayrimenkul davaları.", description_en: "Title deed transactions, rental disputes and real estate cases.", detail_tr: "Gayrimenkul hukuku alanında kapsamlı danışmanlık.", detail_en: "Comprehensive consultancy in real estate law.", category: "realestate", icon: "Home", slug: "gayrimenkul-hukuku", is_active: true },
];

const articles = [
  {
    id: "a1",
    title: "Ceza Hukukunda Meşru Müdafaa: Şartları, Sınırları ve Güncel Yargıtay Kararları",
    content: `Meşru müdafaa, Türk Ceza Kanunu'nun 25. maddesi kapsamında düzenlenen ve kişinin kendisini veya başkasını hukuka aykırı bir saldırıya karşı korumasına olanak tanıyan temel bir hukuka uygunluk nedenidir.

Meşru Müdafaanın Şartları

Meşru müdafaa hakkının doğması için belirli koşulların bir arada bulunması gerekmektedir. Öncelikle, ortada haksız bir saldırının bulunması zorunludur. Bu saldırının gerçekleşmiş, devam etmekte olan veya tekrarlanması kesin olan bir nitelik taşıması şarttır. Gelecekte gerçekleşmesi muhtemel ancak kesin olmayan saldırılara karşı meşru müdafaa hakkı kullanılamaz.

Saldırının Niteliği ve Orantılılık İlkesi

Saldırıya karşı gösterilen savunmanın, saldırı ile orantılı olması büyük önem taşır. Yargıtay içtihatlarına göre, saldırganın elinde bıçak varken silahla karşılık vermek orantılılık ilkesine aykırı düşebilir. Ancak her somut olay, kendi koşulları içinde değerlendirilmektedir.

Meşru Müdafaada Sınırın Aşılması

TCK'nın 27. maddesi, meşru müdafaada sınırın aşılması halini düzenlemektedir. Buna göre, korkudan veya heyecandan kaynaklanan bir mazeret söz konusu olduğunda, sınırın aşılması halinde ceza indirimi veya cezasızlık kararı verilebilir.

Güncel Yargıtay Kararlarından Örnekler

Yargıtay Ceza Genel Kurulu'nun emsal niteliğindeki kararlarında, ev sahibinin gece vakti evine izinsiz giren kişiye karşı kullandığı gücün meşru müdafaa kapsamında değerlendirildiği görülmektedir. Benzer şekilde, iş yerinde saldırıya uğrayan kişinin orantılı savunması da meşru müdafaa olarak kabul edilmektedir.

Sonuç

Meşru müdafaa hakkı, temel bir insan hakkı olan yaşama hakkının korunmasıyla doğrudan ilişkilidir. Ancak bu hakkın kullanımında orantılılık ilkesine dikkat edilmesi, gereksiz güç kullanımından kaçınılması büyük önem taşımaktadır.`,
    excerpt: "Meşru müdafaa hakkının şartları, orantılılık ilkesi ve güncel Yargıtay kararları ışığında kapsamlı bir inceleme.",
    category: "ceza-hukuku",
    tags: ["ceza-hukuku", "meşru-müdafaa", "yargıtay-kararları", "TCK"],
    cover_image: "",
    slug: "ceza-hukukunda-mesru-mudafaa",
    seo_title: "Ceza Hukukunda Meşru Müdafaa Hakkı | Av. Samet Öztürk",
    meta_description: "Meşru müdafaa hakkının şartları, sınırları ve güncel Yargıtay kararları hakkında detaylı hukuki analiz.",
    is_featured: true,
    status: "published",
    author: "Av. Samet Öztürk",
    view_count: 156,
    created_at: "2026-06-15T10:00:00Z",
    updated_at: "2026-06-15T10:00:00Z"
  },
  {
    id: "a2",
    title: "Anlaşmalı Boşanma Süreci: Protokol Hazırlama, Şartlar ve Dikkat Edilmesi Gerekenler",
    content: `Anlaşmalı boşanma, Türk Medeni Kanunu'nun 166/3. maddesi kapsamında düzenlenen ve eşlerin karşılıklı irade beyanlarıyla evlilik birliğini sona erdirdikleri bir boşanma türüdür. Bu süreç, çekişmeli boşanmaya göre hem daha hızlı hem de daha az yıpratıcıdır.

Anlaşmalı Boşanmanın Temel Şartları

Anlaşmalı boşanma için evliliğin en az bir yıl sürmüş olması kanuni bir zorunluluktur. Eşlerin birlikte mahkemeye başvurması veya bir eşin açtığı davayı diğer eşin kabul etmesi gerekmektedir. Hâkimin her iki tarafı da bizzat dinlemesi şarttır; vekâleten anlaşmalı boşanma mümkün değildir.

Boşanma Protokolünün Hazırlanması

Boşanma protokolü, anlaşmalı boşanmanın en kritik belgesidir. Bu protokolde şu hususların açık ve net bir şekilde düzenlenmesi gerekmektedir:

Mal paylaşımı: Taşınır ve taşınmaz malların nasıl paylaşılacağı, banka hesapları, araç ve diğer varlıkların durumu detaylı şekilde belirtilmelidir.

Nafaka: Yoksulluk nafakası talep edilip edilmeyeceği, miktarı ve süresi belirlenmelidir. Çocuk varsa iştirak nafakası da ayrıca düzenlenmelidir.

Velayet: Müşterek çocukların velayetinin hangi eşe bırakılacağı, diğer eşin kişisel ilişki kurma hakkının kapsamı ve zamanlaması netleştirilmelidir.

Tazminat: Maddi ve manevi tazminat talepleri varsa bunların karşılıklı olarak düzenlenmesi gerekmektedir.

Mahkeme Süreci

Anlaşmalı boşanma davası genellikle tek celsede sonuçlanır. Hâkim, protokolü inceledikten sonra her iki tarafı da ayrı ayrı dinler. Protokolün hakkaniyete uygun olduğuna ve özellikle çocukların menfaatinin korunduğuna kanaat getirirse boşanmaya karar verir.

Dikkat Edilmesi Gereken Hususlar

Protokoldeki belirsiz ifadeler ileride uyuşmazlıklara neden olabilir. Bu nedenle bir avukat eşliğinde hazırlanması tavsiye edilir. Ayrıca, protokolde yer almayan konularda sonradan hak talep etmek güçleşebilir.`,
    excerpt: "Anlaşmalı boşanma süreci, protokol hazırlama, mal paylaşımı, velayet ve nafaka düzenlemesi hakkında kapsamlı rehber.",
    category: "aile-hukuku",
    tags: ["aile-hukuku", "boşanma", "anlaşmalı-boşanma", "nafaka", "velayet"],
    cover_image: "",
    slug: "anlasmali-bosanma-sureci",
    seo_title: "Anlaşmalı Boşanma Süreci Rehberi | Av. Samet Öztürk",
    meta_description: "Anlaşmalı boşanma süreci, protokol hazırlama, şartlar ve dikkat edilmesi gerekenler hakkında detaylı rehber.",
    is_featured: true,
    status: "published",
    author: "Av. Samet Öztürk",
    view_count: 243,
    created_at: "2026-06-10T10:00:00Z",
    updated_at: "2026-06-10T10:00:00Z"
  },
  {
    id: "a3",
    title: "İşçi Hakları: Kıdem Tazminatı, İhbar Tazminatı ve Fazla Mesai Alacakları",
    content: `İş hukuku, işçi ile işveren arasındaki ilişkileri düzenleyen ve işçinin haklarını koruyan temel hukuk dallarından biridir. 4857 sayılı İş Kanunu, işçilerin sahip olduğu hakları ve işverenin yükümlülüklerini detaylı şekilde belirlemiştir.

Kıdem Tazminatı

Kıdem tazminatı, işçinin aynı işverene bağlı olarak en az bir yıl çalışmış olması koşuluyla hak kazandığı tazminattır. Her tam çalışma yılı için 30 günlük brüt ücret tutarında hesaplanır.

Kıdem tazminatına hak kazanma halleri şunlardır: İşveren tarafından haklı neden olmaksızın fesih, işçi tarafından haklı nedenle fesih (SGK'lık süreyi doldurma, askerlik, evlilik vb.), emeklilik nedeniyle ayrılma ve kadın işçinin evlenme tarihinden itibaren bir yıl içinde ayrılması.

İhbar Tazminatı

İhbar tazminatı, iş sözleşmesini feshetmek isteyen tarafın diğer tarafa önceden bildirimde bulunma yükümlülüğünü yerine getirmemesi halinde ödenen tazminattır.

İhbar süreleri çalışma süresine göre değişmektedir: 6 aydan az çalışma için 2 hafta, 6 ay-1.5 yıl arası için 4 hafta, 1.5-3 yıl arası için 6 hafta, 3 yıldan fazla çalışma için 8 hafta bildirim süresi öngörülmüştür.

Fazla Mesai Alacakları

Haftalık 45 saati aşan çalışmalar fazla mesai olarak değerlendirilir. Fazla mesai ücreti, normal çalışma ücretinin %50 fazlasıyla ödenir. İşverenin yazılı onay almadan fazla mesai yaptırması hâlinde işçi, bu ücreti talep etme hakkına sahiptir.

Yıllık İzin Hakkı

İşçinin yıllık ücretli izin hakkı kıdemine göre belirlenir: 1-5 yıl arası çalışma için en az 14 gün, 5-15 yıl arası için en az 20 gün, 15 yıldan fazla çalışma için en az 26 gün yıllık izin hakkı bulunmaktadır.

İş Davası Açma Süreci

İş davası açmadan önce arabuluculuk başvurusu zorunludur. Arabuluculuk sürecinden sonuç alınamaması hâlinde iş mahkemesine dava açılabilir. Zamanaşımı süreleri dikkate alınarak en kısa sürede hukuki süreci başlatmak büyük önem taşımaktadır.`,
    excerpt: "Kıdem tazminatı hesaplama, ihbar tazminatı, fazla mesai alacakları ve yıllık izin hakkı hakkında kapsamlı iş hukuku rehberi.",
    category: "is-hukuku",
    tags: ["iş-hukuku", "kıdem-tazminatı", "ihbar-tazminatı", "fazla-mesai", "işçi-hakları"],
    cover_image: "",
    slug: "isci-haklari-kidem-tazminati",
    seo_title: "İşçi Hakları ve Kıdem Tazminatı Rehberi | Av. Samet Öztürk",
    meta_description: "İşçi hakları, kıdem tazminatı, ihbar tazminatı, fazla mesai alacakları ve iş davası süreci hakkında kapsamlı rehber.",
    is_featured: false,
    status: "published",
    author: "Av. Samet Öztürk",
    view_count: 189,
    created_at: "2026-06-05T10:00:00Z",
    updated_at: "2026-06-05T10:00:00Z"
  },
  {
    id: "a4",
    title: "Ticaret Hukukunda Şirket Kurulumu: Limited ve Anonim Şirket Karşılaştırması",
    content: `Türkiye'de şirket kurmak isteyen girişimcilerin en sık tercih ettiği iki şirket türü limited şirket ve anonim şirkettir. Her iki şirket türünün kendine özgü avantajları ve dezavantajları bulunmaktadır.

Limited Şirket (Ltd. Şti.)

Limited şirket, en az 10.000 TL sermaye ile kurulabilir. Ortak sayısı en az 1, en fazla 50 kişi olabilir. Sermaye payları nama yazılıdır ve devrinde belirli kısıtlamalar mevcuttur.

Limited şirketin avantajları arasında düşük kuruluş maliyeti, daha basit yönetim yapısı ve daha az bürokrasi sayılabilir. Dezavantajları ise halka arz imkânının bulunmaması ve ortak sayısının sınırlı olmasıdır.

Anonim Şirket (A.Ş.)

Anonim şirket, en az 50.000 TL sermaye ile kurulabilir. Ortak sayısında üst sınır bulunmaz. Hisse senetleri serbestçe devredilebilir ve halka arz imkânı mevcuttur.

Anonim şirketin avantajları arasında daha yüksek kurumsal itibar, halka arz imkânı, hisse devir kolaylığı ve daha geniş finansman olanakları yer alır.

Şirket Kurulum Adımları

Ticaret sicili işlemleri, vergi dairesi kaydı, SGK işlemleri, imza sirküleri hazırlanması ve gerekli izinlerin alınması kurulum sürecinin temel adımlarıdır.

Hangi Şirket Türü Tercih Edilmeli?

Küçük ve orta ölçekli işletmeler genellikle limited şirketi tercih ederken, büyük ölçekli yatırımlar ve halka açılma hedefi olan girişimler için anonim şirket daha uygun olacaktır. Doğru tercih için mutlaka bir hukuk danışmanından destek alınması önerilir.`,
    excerpt: "Limited şirket ve anonim şirket arasındaki farklar, kuruluş süreçleri ve doğru şirket türü seçimi rehberi.",
    category: "ticaret-hukuku",
    tags: ["ticaret-hukuku", "şirket-kurulumu", "limited-şirket", "anonim-şirket"],
    cover_image: "",
    slug: "ticaret-hukukunda-sirket-kurulumu",
    seo_title: "Şirket Kurulumu Rehberi: Limited ve Anonim Şirket | Av. Samet Öztürk",
    meta_description: "Türkiye'de limited şirket ve anonim şirket kurulumu, farkları ve doğru tercih rehberi.",
    is_featured: false,
    status: "published",
    author: "Av. Samet Öztürk",
    view_count: 127,
    created_at: "2026-05-28T10:00:00Z",
    updated_at: "2026-05-28T10:00:00Z"
  },
  {
    id: "a5",
    title: "İcra ve İflas Hukuku: Alacak Takibi Süreçleri ve Borçlu Hakları",
    content: `İcra ve iflas hukuku, alacaklının alacağını devlet gücü aracılığıyla tahsil etmesini sağlayan hukuk dalıdır. Bu alanda hem alacaklının hem de borçlunun haklarını bilmesi, sürecin sağlıklı yürümesi açısından büyük önem taşımaktadır.

İcra Takibi Türleri

İlamsız icra takibi, mahkeme kararı olmaksızın doğrudan icra müdürlüğüne başvurularak başlatılır. Borçlu, ödeme emrine 7 gün içinde itiraz edebilir. İtiraz hâlinde takip durur ve alacaklının itirazın kaldırılması davası açması gerekir.

İlamlı icra takibi ise mahkeme kararına dayanan bir takip türüdür. Bu takipte borçlunun itiraz hakkı sınırlıdır.

Kambiyo senetlerine dayalı icra takibi, çek, senet ve poliçe gibi kıymetli evraklara dayanan özel bir takip yoludur. Borçlu 5 gün içinde itiraz edebilir.

Borçlunun Hakları

Borçlunun temel hakları arasında itiraz hakkı, meskeniyet (ev haczinin kaldırılması) iddiası, haczedilemeyen mallar listesi kapsamındaki korumalar ve menfi tespit davası açma hakkı bulunmaktadır.

Sonuç

İcra süreçleri karmaşık ve teknik detaylar içeren süreçlerdir. Hem alacaklı hem de borçlu tarafının haklarını en iyi şekilde koruyabilmesi için uzman bir avukattan destek alması önerilmektedir.`,
    excerpt: "İcra takibi türleri, alacak tahsil süreçleri ve borçlu hakları hakkında kapsamlı hukuki rehber.",
    category: "icra-iflas",
    tags: ["icra-hukuku", "iflas-hukuku", "alacak-takibi", "borçlu-hakları"],
    cover_image: "",
    slug: "icra-iflas-hukuku-alacak-takibi",
    seo_title: "İcra ve İflas Hukuku Rehberi | Av. Samet Öztürk",
    meta_description: "İcra takibi türleri, alacak tahsil süreçleri, borçlu hakları ve hukuki süreç hakkında detaylı rehber.",
    is_featured: false,
    status: "published",
    author: "Av. Samet Öztürk",
    view_count: 98,
    created_at: "2026-05-20T10:00:00Z",
    updated_at: "2026-05-20T10:00:00Z"
  },
  {
    id: "a6",
    title: "Miras Hukuku: Yasal Mirasçılık, Vasiyetname ve Miras Paylaşımı",
    content: `Miras hukuku, bir kişinin ölümü hâlinde malvarlığının kimlere ve nasıl intikal edeceğini düzenleyen hukuk dalıdır. Türk Medeni Kanunu'nun 495-682. maddeleri arasında detaylı olarak düzenlenmiştir.

Yasal Mirasçılık Sistemi

Türk hukukunda zümre sistemi uygulanmaktadır. Birinci zümre mirasçılar miras bırakanın altsoyu (çocukları, torunları), ikinci zümre ana ve babası ile onların altsoyu, üçüncü zümre ise büyük ana ve büyük babası ile onların altsoyudur.

Sağ kalan eş, hangi zümre ile birlikte mirasçı olduğuna bağlı olarak farklı oranlarda miras payı alır. Birinci zümre ile birlikte 1/4, ikinci zümre ile birlikte 1/2, üçüncü zümre ile birlikte 3/4 oranında miras payına sahiptir.

Vasiyetname Türleri

El yazılı vasiyetname, resmî vasiyetname ve sözlü vasiyetname olmak üzere üç tür vasiyetname bulunmaktadır. En güvenli yöntem, noter huzurunda düzenlenen resmî vasiyetnamedir.

Saklı Pay Hakkı

Bazı mirasçıların saklı pay hakları bulunmaktadır. Bu hak, miras bırakanın tasarruf özgürlüğünü sınırlar. Saklı pay oranları mirasçının yakınlık derecesine göre değişmektedir.

Sonuç

Miras hukuku konularında erken dönemde hukuki danışmanlık almak, ileride yaşanabilecek uyuşmazlıkların önlenmesi açısından büyük önem taşır.`,
    excerpt: "Yasal mirasçılık sistemi, vasiyetname türleri, saklı pay hakları ve miras paylaşımı hakkında kapsamlı rehber.",
    category: "miras-hukuku",
    tags: ["miras-hukuku", "vasiyetname", "saklı-pay", "miras-paylaşımı"],
    cover_image: "",
    slug: "miras-hukuku-yasal-mirascilik",
    seo_title: "Miras Hukuku Rehberi: Mirasçılık ve Vasiyetname | Av. Samet Öztürk",
    meta_description: "Yasal mirasçılık, vasiyetname türleri, saklı pay hakları ve miras paylaşımı hakkında hukuki rehber.",
    is_featured: false,
    status: "published",
    author: "Av. Samet Öztürk",
    view_count: 76,
    created_at: "2026-05-12T10:00:00Z",
    updated_at: "2026-05-12T10:00:00Z"
  },
];

const articleCategories = [
  { slug: "ceza-hukuku", name: "Ceza Hukuku" }, { slug: "aile-hukuku", name: "Aile Hukuku" },
  { slug: "is-hukuku", name: "İş Hukuku" }, { slug: "ticaret-hukuku", name: "Ticaret Hukuku" },
  { slug: "icra-iflas", name: "İcra ve İflas Hukuku" }, { slug: "miras-hukuku", name: "Miras Hukuku" },
  { slug: "tuketici-hukuku", name: "Tüketici Hukuku" }, { slug: "gayrimenkul", name: "Gayrimenkul Hukuku" },
  { slug: "guncel", name: "Güncel Hukuki Bilgilendirmeler" }, { slug: "yargi-kararlari", name: "Yargı Kararları" },
];

const allTimeSlots = ["09:00","09:30","10:00","10:30","11:00","11:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00","16:30","17:00"];

export { services, articles, articleCategories, allTimeSlots };
